import * as React from "react";
const SvgFiRrUsersSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-users-slash_svg__a)">
      <path
        fill="#062147"
        d="M18 8c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4m0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2m-.12 20.801a1 1 0 1 1-1.96.398A4.01 4.01 0 0 0 12 20a4.01 4.01 0 0 0-3.92 3.2 1 1 0 0 1-1.96-.398A6.02 6.02 0 0 1 12 18a6.02 6.02 0 0 1 5.88 4.801m.12-13.8a6.02 6.02 0 0 1 5.88 4.8 1 1 0 1 1-1.96.398A4.01 4.01 0 0 0 18 11a1 1 0 0 1 0-2m-12.016.901a1 1 0 0 1-.805 1.163A4.03 4.03 0 0 0 1.98 14.2a1 1 0 1 1-1.96-.398 6.04 6.04 0 0 1 4.801-4.705 1 1 0 0 1 1.163.805zm17.723 12.391-7.94-7.94C15.92 13.925 16 13.47 16 13a3.97 3.97 0 0 0-1.172-2.828c-1.085-1.085-2.749-1.39-4.16-.918L8.52 7.106A4 4 0 0 0 10 4c0-2.206-1.794-4-4-4-1.226 0-2.36.563-3.106 1.48L1.707.293A.999.999 0 1 0 .293 1.707l22 22a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414M6 2a2.002 2.002 0 0 1 1.091 3.677L4.323 2.91A2 2 0 0 1 6 2m3.367 13.633a3.97 3.97 0 0 1-1.14-2.373c-.05-.44.481-.7.795-.386l3.104 3.104a.468.468 0 0 1-.386.796 3.97 3.97 0 0 1-2.373-1.14"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-users-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUsersSlash;
